// Entry point for the standalone marketing landing — deployed to Render's
// static-site service so it's CDN-cached and always instant.
//
// Differences from src/main.tsx:
//   - No <BrowserRouter>: single page, no client routing.
//   - Wraps in QueryClientProvider so useCurrentUser() can call /auth/me on
//     the app subdomain (cross-origin, credentialed).
//   - Fires a silent /api/health ping on load to wake the API web service.

import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import HomeLanding from "./HomeLanding";
import { wakeUp } from "./wakeUp";
import "@/index.css";
import { applyTheme } from "@/store/uiStore";

// Match the SPA's default theme so visual styling lines up.
applyTheme(false, 0);

wakeUp();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 30_000 },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <HomeLanding />
    </QueryClientProvider>
  </React.StrictMode>,
);
